import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1>KAM Memecoin</h1>
    </header>
  );
};

export default Header;